import React from 'react'
import PropTypes from 'prop-types'
import { EyeIcon, EyeOffIcon, LinkIcon } from '@heroicons/react/solid'

import classNames from '@/utils/classNamesLocal'

// Public / unlisted / private as a labeled segmented control, so the state is
// readable without opening anything. Used on submission and project rows.
export const VISIBILITY_OPTIONS = [
  { value: 'public', label: 'Public', icon: EyeIcon },
  { value: 'unlisted', label: 'Unlisted', icon: LinkIcon },
  { value: 'private', label: 'Private', icon: EyeOffIcon }
]

const VisibilityControl = ({ value, onChange, options = VISIBILITY_OPTIONS, size = 'sm' }) => (
  <div role='group' aria-label='Visibility' className='inline-flex rounded-full bg-gray-100 p-0.5 dark:bg-gray-700'>
    { options.map((o) => (
      <button key={o.value} type='button' onClick={() => onChange(o.value)} aria-pressed={value === o.value} title={o.label}
        className={classNames('inline-flex items-center gap-x-1 rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-cccblue',
          size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm',
          value === o.value ? 'bg-white text-gray-900 shadow-sm dark:bg-gray-900 dark:text-white' : 'text-gray-500 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white')}>
        <o.icon className='h-3.5 w-3.5' /><span className={value === o.value ? '' : 'hidden sm:inline'}>{o.label}</span>
      </button>
    ))}
  </div>
)

export default VisibilityControl

VisibilityControl.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  size: PropTypes.oneOf(['sm', 'md'])
}
